import { TaskListItem } from "@coworker/apprestructured/src/TasksOverview/hooks/useTasksOverview";
import { useState } from "react";
import { useCloseReasonOptions } from "./api/useCloseReasonOptions";
import { useModal } from "./useModal";

export const useCloseSheetModal = (tasks: TaskListItem[]) => {
  const { shown, open, close } = useModal(false);

  const [closeReasonId, setCloseReasonId] = useState<string | null>(null);
  const [description, setDescription] = useState("");

  const handleClose = () => {
    close();
    setCloseReasonId(null);
    setDescription("");
  };

  const { closeReasonOptions, isLoading: closeReasonOptionsAreLoading } =
    useCloseReasonOptions(tasks, { enabled: shown });

  return {
    shown,
    open,
    close: handleClose,

    closeReasonId,
    setCloseReasonId,

    description,
    setDescription,

    closeReasonOptions,
    closeReasonOptionsAreLoading,
  };
};
